import { prepareGalleryImageForLayout } from './prepareGalleryImageForLayout';

import type { GalleryImageField } from '@monoimin/sb-types';

export function pickFirstImageFromGalleryField(field?: GalleryImageField) {
  if (!field) {
    return null;
  }

  const { images } = field;

  if (!Array.isArray(images) || !images?.length) {
    return null;
  }

  return prepareGalleryImageForLayout(images[0]);
}

export default pickFirstImageFromGalleryField;
